export const messages = {
  en: {
    shopManage: {
      search: {
        title: 'Search Conditions',
        shopName: 'Shop Name',
        storeType: 'Shop Type',
        state: 'State'
      },
      list: {
        title: 'Shop Information'
      },
      table: {
        shopLogo: 'Shop Logo',
        shopName: 'Shop Name',
        shopType: 'Shop Type',
        storeName: 'Store Name',
        storeAddress: 'Store Address',
        storeTel: 'Store Tel',
        state: 'State',
        createTime: 'Create Time'
      },
      state: {
        passed: 'Approved',
        rejected: 'Rejected'
      },
      fetchError: 'Failed to fetch shop list',
      fetchStoreTypesError: 'Failed to fetch shop types',
      fetchShopTypesError: "Failed to fetch shop types",
    },
    shopWithdraw: {
      title: 'Please confirm your operation',
      remark: 'Withdraw Remark',
      remarkPlaceholder: 'Required, please fill in the withdraw reason',
      submit: 'Confirm Withdraw',
      remarkRequired: 'Withdraw remark is required',
      success: 'Withdraw successfully',
      error: 'Withdraw failed'
    }
  },
  zh: {
    shopManage: {
      search: {
        title: '查询条件',
        shopName: '店铺名称',
        storeType: '店铺类型',
        state: '状态'
      },
      list: {
        title: '店铺信息'
      },
      table: {
        shopLogo: '店铺logo',
        shopName: '店铺名称',
        shopType: '店铺类型',
        storeName: '商家名称',
        storeAddress: '商家地址',
        storeTel: '联系电话',
        state: '店铺状态',
        createTime: '创建时间'
      },
      state: {
        passed: '审核通过',
        rejected: '审核不通过'
      },
      fetchError: '获取店铺列表失败',
      fetchStoreTypesError: '获取店铺类型失败',
      fetchShopTypesError: "获取商铺类型失败",
    },
    shopWithdraw: {
      title: '请确认您的操作',
      remark: '撤回说明',
      remarkPlaceholder: '必填，请填写撤回意见',
      submit: '确认撤回',
      remarkRequired: '撤回说明必填',
      success: '撤回成功',
      error: '撤回失败'
    }
  }
}